import { RefObject, useCallback, useLayoutEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export const useResizeObserver = (
  ref: RefObject<HTMLElement | null>,
  callback?: (entry: DOMRectReadOnly) => void
) => {
  const [width, setWidth] = useState<number>();
  const [height, setHeight] = useState<number>();

  const handleResize = useCallback(
    (entries: ResizeObserverEntry[]) => {
      if (!Array.isArray(entries)) return;
      const entry = entries[0];
      setWidth(entry.contentRect.width);
      setHeight(entry.contentRect.height);
      callback?.(entry.contentRect);
    },
    [callback]
  );

  useLayoutEffect(() => {
    if (!ref.current) return;
    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(ref.current);
    return () => resizeObserver?.disconnect();
  }, [ref, handleResize]);

  return { width, height };
};
